import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const History = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 아소비 주요 연혁`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });

    // IP 체크 함수
    const checkIP = async () => {
      const response = await fetch("/check-ip");
      const result = await response.json();

      // 리다이렉션 확인
      if (result.redirect) {
        navigate(result.redirect); // navigate로 리다이렉션
      }
    };

    checkIP(); // IP 체크 함수 호출
  }, [location, navigate]); // navigate 추가

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/company">아소비 철학</a>
              </li>
              <li>
                <a href="/history" className="sel">
                  주요 연혁
                </a>
              </li>
              <li>
                <a href="/location">오시는길</a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="history">
          <div className="sect history01 init">
            <div className="img">
              <img src="../custom-resources/img/img_history_history01.png" alt="" />
            </div>
            <div className="sub">제 2의 도약</div>
            <div className="wrap">
              <div className="tit">2020년 ~ 현재</div>
              <div className="txt">
                유기농공부의 아소비 철학으로 사업을 체계화하며 더 큰 도약을 위한
                마음가짐을 다졌습니다. <br />
                기업의 가치를 높여가며 미래를 향한 아소비교육의 힘찬 발걸음을
                이어가겠습니다.
              </div>
              <div className="lst">
                <dl className="init">
                  <dt>2023</dt>
                  <dd>
                    <p>- 전국 1,600개 가맹점 돌파</p>
                    <p>- TV광고(EBS) </p>
                    <p>- 사회/역사 탐구 교재 출시</p>
                    <p>
                      - 2023 한국 브랜드 선호도 1위
                      <br />
                      &nbsp;&nbsp;(유아, 초등저학년교육 부문 2년 연속)
                    </p>
                    <p>- 읽기 쉬운 한글 동화 3종 출간</p>
                  </dd>
                </dl>
                <dl className="init">
                  <dt>2022</dt>
                  <dd>
                    <p>- 전국 1,500개 가맹점 돌파</p>
                    <p>- TV광고(EBS) </p>
                    <p>- 초등심화 교재 출시</p>
                    <p>- 새싹논술 교재 출시</p>
                    <p>- '마법여우주비' 애니메이션 방영(SBS)</p>
                    <p>
                      - 2022 한국 브랜드 선호도 1위
                      <br />
                      &nbsp;&nbsp;(유아, 초등저학년교육 부문)
                    </p>
                    <p>- 한국프랜차이즈대상 협회장상 수상</p>
                    <p>- 우수프랜차이즈 선정(4년 연속)</p>
                    <p>- 50회 서울국제유아교육전 참가</p>
                  </dd>
                </dl>
                <dl className="init">
                  <dt>2021</dt>
                  <dd>
                    <p>- 전국 1,200개 가맹점 달성</p>
                    <p>- IFS 프랜차이즈 서울 참가</p>
                    <p>- 아소비 칠교대장 개최</p>
                    <p>- 아소비 한글대장 개최</p>
                    <p>- &lt;대한민국 명품브랜드 대상&gt;</p>
                    <p>- 공부방 프랜차이즈 부문 대상 선정</p>
                    <p>- &lt;2021 한국프랜차이즈 산업발전 유공&gt;</p>
                    <p>- 산업통상자원부 장관 표창 수상</p>
                    <p>- 한국공정거래조정원 2021 착한프랜차이즈 선정</p>
                    <p>
                      - &lt;받침 없는 동화&gt; ‘하이! 지구’ 양장본 동화책 발간
                    </p>
                    <p>- 온라인 입학설명회 개최</p>
                    <p>- TV, 라디오 광고 진행</p>
                  </dd>
                </dl>
                <dl className="init">
                  <dt>2020</dt>
                  <dd>
                    <p>- 아소비 법인 설립 10주년</p>
                    <p>- 본사 사옥 이전</p>
                    <p>- 프랜차이즈 수준평가 1등급</p>
                    <p>- 우수프랜차이즈 선정(2년 연속)</p>
                    <p>- 예비 초등 3학년 과정 출시</p>
                    <p>- &lt;받침 없는 동화&gt; 3종 출시</p>
                    <p>- 밀알복지재단 방역 물품 기부</p>
                    <p>- 온라인 스트리밍 입학설명회 개최</p>
                    <p>- 소중한 비전을 위해 공부하는 자녀들</p>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
          <div className="sect history02 init">
            <div className="img">
              <img src="../custom-resources/img/img_history_history02.png" alt="" />
            </div>
            <div className="sub">창업과 개척</div>
            <div className="wrap">
              <div className="tit">2010년 ~ 2019년</div>
              <div className="txt">
                아소비의 시작은 우리 아이들의 배움을 행복하게 즐길 수 있기를
                바라며 연구해왔습니다. <br />
                고학년이 되면 배움에 지치고 힘들어 하는 아이들이 없도록 하기
                위해 새로운 교재를 연구, 개발하고 <br />
                교육의 프랜차이즈화를 선보이며 교육 사업의 틀을 다졌습니다.
              </div>
              <div className="lst">
                <dl className="init">
                  <dt>2019</dt>
                  <dd>
                    <p>- 전국 1,000개 가맹점 달성</p>
                    <p>- 프랜차이즈 수준평가 1등급</p>
                    <p>- 우수프랜차이즈 선정</p>
                    <p>- 우수교육원 선정(전국 60개점)</p>
                    <p>- 선임교육원 지정(전국 36개점)</p>
                    <p>- 수석교육원 지정(전국 15개점)</p>
                    <p>- 교육원 취미 활동 지원(작심 6개월)</p>
                    <p>- 아소비 한글대장 개최</p>
                    <p>- 아소비 칠교대장을 찾아라 개최</p>
                    <p>- &lt;주비아삭꾸르&gt;캐릭터 제작, 발표</p>
                  </dd>
                </dl>
                <dl className="init">
                  <dt>2018</dt>
                  <dd>
                    <p>- 전국 900개 가맹점 돌파</p>
                    <p>- 전속모델 발탁 : V.O.S 박지헌</p>
                    <p>- 본사, 교육장 확장 이전</p>
                    <p>- 2018 우수교육원 선정(전국 45개점)</p>
                    <p>- 선임교육원 지정(전국 20개점)</p>
                    <p>- 수석 교육원 지정(전국 7개점)</p>
                    <p>- 2018 아소비 워라밸의 여왕을 찾아라 개최</p>
                    <p>- 2018 아소비의 밤 개최</p>
                    <p>- &lt;받침 없는 동화&gt; 2종 출시</p>
                    <p>- 40회 서울국제유아교육전 참가(3년 연속)</p>
                    <p>- 밀알복지재단 업무 협약 체결</p>
                    <p>- 밀알복지재단 연계 어린이미래인성교육 실시</p>
                    <p>- 남양주시 드림스타트 기초학습지도 협약 체결</p>
                    <p>- 둥지지역아동센터 교육 봉사 실시</p>
                  </dd>
                </dl>
                <dl className="init">
                  <dt>2017</dt>
                  <dd>
                    <p>
                      - &lt;대한민국교육기업대상&gt; 공부방 부문 대상 수상(2회
                      연속)
                    </p>
                    <p>
                      - &lt;2017한국브랜드선호도1위&gt; 프랜차이즈 공부방 부문
                      수상
                    </p>
                    <p>- 독해논리/창의논술/창의수학 출시</p>
                    <p>
                      - &lt;제14회 대한민국창업대상&gt; 산업통상자원부장관상
                      수상
                    </p>
                    <p>- 전국 800개 가맹점 돌파</p>
                    <p>- SBS&lt;영재 발굴단&gt; 제작 지원</p>
                    <p>- SBS&lt;동상이몽 시즌2-너는 내 운명&gt; 제작 지원</p>
                    <p>- 40회 서울국제유아교육전 참가</p>
                  </dd>
                </dl>
                <dl className="init">
                  <dt>2016</dt>
                  <dd>
                    <p>- &lt;대한민국교육기업대상&gt; 공부방 부문 대상 수상</p>
                    <p>- 전국 33개 지사 개설</p>
                    <p>- 전국 550개 가맹점 개설</p>
                    <p>- 베이직프로그램 출시</p>
                    <p>- EBS&lt;모여라 딩동댕&gt; 제작 지원</p>
                    <p>- SBS&lt;미운우리새끼&gt; 제작 지원</p>
                    <p>- 38회 서울국제유아교육전 참가</p>
                  </dd>
                </dl>
                <dl className="init">
                  <dt>2015</dt>
                  <dd>
                    <p>- 한글 교재 특허 취득</p>
                    <p>- 언어능력 향상 프로그램 출시</p>
                    <p>- KBS 1TV &lt;이웃집 찰스&gt; 방영</p>
                  </dd>
                </dl>
                <dl className="init">
                  <dt>2014</dt>
                  <dd>
                    <p>- 전국 350여개 가맹점 개설</p>
                    <p>- 학습향상프로그램 출시</p>
                  </dd>
                </dl>
                <dl className="init">
                  <dt>2010</dt>
                  <dd>
                    <p>- (주)아소비교육 법인 전환</p>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
          <div className="sect history03 init">
            <div className="img">
              <img src="../custom-resources/img/img_history_history03.png" alt="" />
            </div>
            <div className="sub">아소비 시작</div>
            <div className="wrap">
              <div className="tit">2002년 ~ 2009년</div>
              <div className="txt">
                교육의길을 걷기 시작하면서 늘 고민은 왜 아이들은 행복하게
                공부하지 못하는가!? <br />이 물음에 해답을 제시하고자 연구,
                개발하여 아소비 교재를 제작하게 됩니다.{" "}
              </div>
              <div className="lst">
                <dl className="init">
                  <dt>2009</dt>
                  <dd>
                    <p>- 아소비공부방 프랜차이즈 출발</p>
                    <p>- 지사 설립</p>
                  </dd>
                </dl>
                <dl className="init">
                  <dt>2003</dt>
                  <dd>
                    <p>- 유치원, 어린이집, 기관에 교재 공급</p>
                  </dd>
                </dl>
                <dl className="init">
                  <dt>2002</dt>
                  <dd>
                    <p>- 아소비 교재 출시</p>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default History;
